import { ScrollingNumberCounter, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { type SxProps } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { TopLeftBackButton } from "@src/appV2/redesign/components/TopLeftBackButton";

interface YourScoreStepProps {
  score: number;
  onNext: () => void;
  onBack: () => void;
  sx?: SxProps;
}

const SCORE_ANIMATION_DURATION_MS = 1500;

export function YourScoreStep(props: YourScoreStepProps) {
  const { onNext, onBack, sx, score } = props;

  return (
    <Stack
      spacing={6}
      alignItems="center"
      sx={{
        width: "100%",
        height: "100%",
        justifyContent: "space-between",
        // oxlint-disable-next-line typescript/no-misused-spread -- MUI SxProps union includes functions, but spreading in sx is standard MUI pattern
        ...sx,
      }}
    >
      <Box sx={{ width: "100%" }}>
        <TopLeftBackButton iconType="chevron-left" onClick={onBack} />
      </Box>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: 5,
        }}
      >
        <Stack spacing={6} alignItems="center" sx={{ width: "100%" }}>
          <Text variant="caption" sx={{ color: (t) => t.palette.text.tertiary, fontSize: 16 }}>
            Your Clipboard Score
          </Text>
          <Box sx={{ transform: "scale(1.5)" }}>
            <ScrollingNumberCounter
              startValue={0}
              endValue={score || 100}
              duration={SCORE_ANIMATION_DURATION_MS}
              variant="h1"
            />
          </Box>

          <Text variant="body1" sx={{ color: (t) => t.palette.text.secondary, maxWidth: 343 }}>
            Your score is a reflection of your track record of reliability with Clipboard. It starts
            at 100, but the sky’s the limit!
          </Text>
        </Stack>
      </Box>

      <Button
        fullWidth
        size="large"
        variant="contained"
        sx={{ borderRadius: 999, height: 56 }}
        onClick={onNext}
      >
        Continue
      </Button>
    </Stack>
  );
}
